(() => {
  const root = document.querySelector('[data-si-support-widget]');
  if (!root || root.dataset.ready === 'true') return;
  const dialog = root.querySelector('[data-si-support-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  root.dataset.ready = 'true';
  const launcher = root.querySelector('[data-si-support-open]');
  const form = root.querySelector('form');
  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    document.documentElement.classList.add('si-support-modal-open');
    const first = dialog.querySelector('input:not([type="hidden"]):not([readonly]), [data-si-support-login]');
    first?.focus();
  };
  launcher.hidden = false;
  launcher.addEventListener('click', open);
  root.querySelector('[data-si-support-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('si-support-modal-open');
    launcher.focus();
  });
  if (!form) return;
  const identity = root.querySelector('[data-si-support-identity]');
  const message = root.querySelector('[data-si-support-message]');
  const email = root.querySelector('[data-si-support-email]');
  const confirm = root.querySelector('[data-si-support-email-confirm]');
  const order = root.querySelector('[data-si-support-order]');
  const next = root.querySelector('[data-si-support-next]');
  const summary = root.querySelector('[data-si-support-summary]');
  const content = root.querySelector('.si-support-widget__content');
  const response = root.querySelector('[data-si-support-response]');
  const returnedToWidget = window.location.hash === '#SiSupportWidgetForm' && response;
  const detailsValid = () => {
    email.setCustomValidity('');
    confirm.setCustomValidity('');
    order.setCustomValidity('');
    email.value = email.value.trim();
    confirm.value = confirm.value.trim();
    order.value = order.value.trim();
    if (email.value.toLowerCase() !== confirm.value.toLowerCase()) confirm.setCustomValidity('Email addresses do not match. Please check both fields.');
    if (!order.value) order.setCustomValidity('Enter your order number.');
    return [email, confirm, order].every((input) => input.reportValidity());
  };
  const showIdentity = (focus = true) => {
    identity.hidden = false;
    message.hidden = true;
    message.disabled = true;
    if (focus) email.focus();
  };
  const showMessage = () => {
    identity.hidden = true;
    message.hidden = false;
    message.disabled = false;
    summary.hidden = false;
    root.querySelector('[data-si-support-summary-email]').textContent = email.value;
    root.querySelector('[data-si-support-summary-order]').textContent = `Order ${order.value}`;
    dialog.scrollTop = 0;
    if (content) content.scrollTop = 0;
    message.querySelector('select').focus();
  };
  next.hidden = false;
  showIdentity(false);
  [email, confirm, order].forEach((input) => input.addEventListener('input', () => {
    email.setCustomValidity(''); confirm.setCustomValidity(''); order.setCustomValidity('');
  }));
  next.addEventListener('click', () => { if (detailsValid()) showMessage(); });
  identity.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') { event.preventDefault(); next.click(); }
  });
  root.querySelector('[data-si-support-back]').addEventListener('click', () => showIdentity());
  form.addEventListener('submit', (event) => {
    if (!detailsValid()) { event.preventDefault(); showIdentity(); }
  });
  if (returnedToWidget) {
    confirm.value = email.value;
    open();
    if (email.value && order.value) showMessage();
    response.focus();
  }
})();
